// KWANKGM04010_借入申込詳細
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import { SetShelfInfo, ShelfInfoObj } from '../../types/FileUpload';
import FooterExaminationApplicantUpload from '../../organisms/FooterExaminationApplicantUpload';
import FileUpload from '../../templates/FileUpload';
import { GuarantorInfo } from '../../types/Template';

interface Props {
  reception_id: number;
  reception_cd: string;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  status_code: number;
  step_navigation: StepType;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  looks_inactive: boolean;
  movePrevStep: () => void;
  moveNextStep: () => void;
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  display_status: boolean;
  is_change: boolean;
  loan_type?: string;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const ExaminationFileUpload: React.FC<Props> = ({
  step_navigation,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  shelf_info,
  setShelfInfo,
  reception_id,
  reception_cd,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  status_code,
  movePrevStep,
  moveNextStep,
  looks_inactive,
  guarantors_num,
  guarantor_info,
  display_status,
  is_change,
  loan_type,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        loan_type={item_id}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <FooterExaminationApplicantUpload
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        movePrevStep={movePrevStep}
        moveNextStep={moveNextStep}
        is_change={is_change}
      />
    </>
  );
};

export default ExaminationFileUpload;
